module.exports = __webpack_public_path__ + "static/media/Avatars_Female-04.db847955.png";